import React from "react";
import { useNavigate } from "react-router-dom";
import { ROUTES_LINKS } from "../../routes/routes";
import AdminInput from "../admin/AdminInput";
import Cart from "./Cart";
import MainSearchBar from "./Search/MainSearchBar";

function NavHeader() {
  const navigate = useNavigate();
  const onClickManager =()=>{
    navigate(ROUTES_LINKS.TO_ADMIN_PASSWORD)
  }

  return (
    <>
      <div className="navbar">
        <div className="logo">
          <img onClick={onClickManager} src={require(`../../assets/images/logo.png`)} alt="logo" />
        </div>
        <MainSearchBar />
        {/* <div> <i  style={{color:"darkblue",cursor:"pointer",paddingLeft:35,fontSize:23}} className="fa-solid fa-star">מבצעים</i></div> */}
        <Cart />
        {/* <button className="cart">
          {" "}
          <i
            className="fa-solid fa-envelope"
          ></i>
        </button> */}
        {/* <AdminInput /> */}
        {/* here need to add link of  contact  maby also a link of location*/}
      </div>
    </>
  );
}

export default NavHeader;
